// src/lib/currency/format.ts

function n(v: any, fallback = 0) {
  const x = Number(v)
  return Number.isFinite(x) ? x : fallback
}

const CLEAN_CURRENCIES = new Set(['USD', 'EUR'])

export function formatMoney(value: number, currency = 'MXN', locale = 'es-MX') {
  const amount = n(value, 0)
  const code = String(currency || 'MXN').trim().toUpperCase()

  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)

  // USD -> $100.00
  // EUR -> €100.00
  if (CLEAN_CURRENCIES.has(code)) {
    return formatted
  }

  // MXN -> $100.00 MXN
  // COP -> $100.00 COP
  return `${formatted} ${code}`
}

export function getCurrencySymbol(currency = 'MXN', locale = 'es-MX') {
  const code = String(currency || 'MXN').trim().toUpperCase()

  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).formatToParts(1)

  return parts.find((p) => p.type === 'currency')?.value || code
}

export function shouldShowCurrencyCode(currency = 'MXN') {
  const code = String(currency || 'MXN').trim().toUpperCase()
  return !CLEAN_CURRENCIES.has(code)
}